import {create} from "@/api/rest";

const signOut = {
  signOut: async () => await create('/sign-out'),
};

export default signOut;